"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _class, _descriptor, _descriptor2, _temp, _class3, _descriptor3, _temp2;

var LegalNoticePage = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(LegalNoticePage, _Component2);

  function LegalNoticePage() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, LegalNoticePage);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(LegalNoticePage)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "content", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    return _this2;
  }

  babelHelpers.createClass(LegalNoticePage, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(LegalNoticePageBody, this.content);
    }
  }]);
  return LegalNoticePage;
}(_react.Component), _temp2), (_descriptor3 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "content", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class3);
exports.default = LegalNoticePage;
var LegalNoticePageBody = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(LegalNoticePageBody, _Component);

  function LegalNoticePageBody() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, LegalNoticePageBody);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(LegalNoticePageBody)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "legalNoticeTitle", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "legalNotice", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(LegalNoticePageBody, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "full-height-bg"
      }, _react.default.createElement("div", {
        className: "inner-content container"
      }, _react.default.createElement("h1", null, this.legalNoticeTitle), _react.default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: this.legalNotice
        }
      })));
    }
  }]);
  return LegalNoticePageBody;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "legalNoticeTitle", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "legalNotice", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);